import placeholderImg from '../../assets/images/placeholder.jpg'
import React, { useRef, useEffect, useCallback, useState } from 'react';
import { fetch, fetchByJSON, GetDataFrameInfo, useCachedData, useSimpleForm } from '../../util/util'
import './index.css'
import { push } from 'connected-react-router'
import { useSelector, useDispatch } from 'react-redux'
import { actions as DataSetActions } from '../../reducer/dataset'
import { Checkbox, Modal } from '../../util/ui'
import { Button, MultiSelect, DropDown, Input, Label } from '../../util/ui_components'

import Table from '../common/table'
import { InlineTip } from '../common/tip';
import { result } from 'lodash';
import Sandbox from '../common/sandbox-R'

const reconnectErrorFunction = () => {
  alert('Kernel is taking too much time. Please reduce the data size!')
}

const getCodeFromResult = (result)=> function(){
let para = result.result
let k = -1
let variable_X = []
let target_Y = ""
let tech = -1
let plot_size = -1
let plot_type = -1
let specific_inputVal_lowVar = ""
let specific_inputVal_pca = ""
for(let key in para){
    let value = para[key]
    if(key == "k" && value)k = value
    if(key == "variablesx")variable_X = value
    if(key == "targety")target_Y = value
    if(key == "technique")tech = value
    if(key == "plotsize" && value)plot_size = value
    if(key == "plottype" && value)plot_type = value
    if(key == "specific_inputVal_lowVar" && value)specific_inputVal_lowVar = value
    if(key == "specific_inputVal_pca" && value)specific_inputVal_pca = value
}
if(k === -1){
    k = "length(X)"
}
if(specific_inputVal_lowVar === ""){
    specific_inputVal_lowVar = 0.3
}else{
    specific_inputVal_lowVar = float(specific_inputVal_lowVar)
}
if(plot_size === -1){
    plot_size = "5, 5"
}
if(plot_type != -1){
    let plotTypes = ['bar', 'scatter', 'line', 'heatmap']
    plot_type = plotTypes[plot_type]
}else{
    plot_type = 'bar'
}
if(specific_inputVal_pca === -1){
    specific_inputVal_pca = 2
}
if(tech != -1){
    if(tech === 0){
    let tech = "Variance Threshold: 1-True, 0-False"
    return `
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("reshape2", quietly = TRUE)) {
  install.packages("reshape2")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(reshape2))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))

# Feature Selection Based on Variance Threshold
variances <- apply(df[, X, drop = FALSE], 2, var, na.rm = TRUE) # Compute variance for each feature
selected_features <- names(variances[variances > thresh])  # Select features above the threshold
feature_result <- data.frame(
  Features = names(variances),
  Boolean_Result = ifelse(variances > thresh, 1, 0)
)

# Plotting
if (plotType == "bar") {
  ggplot(feature_result, aes(x = Features, y = Boolean_Result)) +
    geom_bar(stat = "identity", fill = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Boolean Result") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1)) +
    theme(plot.margin = margin(1, 4, 1, 1, "cm"))
} else if (plotType == "scatter") {
  ggplot(feature_result, aes(x = Features, y = Boolean_Result)) +
    geom_point(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Boolean Result") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "line") {
  ggplot(feature_result, aes(x = Features, y = Boolean_Result, group = 1)) +
    geom_line(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Boolean Result") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
}
        `
    }
    if(tech === 1){
    let tech = "Correlation Matrix"
    return`
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("reshape2", quietly = TRUE)) {
  install.packages("reshape2")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(reshape2))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))

# Compute Correlation Matrix
featureResult <- cor(df, use = "complete.obs", method = "pearson")
featureResult_melted <- reshape2::melt(featureResult) # Reshape for ggplot2 (optional)

# Plot
if (plotType == "bar") {
  ggplot(data = featureResult_melted, aes(x = Var1, y = value, fill = Var2)) +
    geom_bar(stat = "identity", position = "dodge") +
    labs(title = title, x = "Features", y = "Correlation") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "scatter") {
  pairs(featureResult, main = title)
} else if (plotType == "line") {
  ggplot(data = featureResult_melted, aes(x = Var1, y = value, group = Var2, color = Var2)) +
    geom_line() +
    labs(title = title, x = "Features", y = "Correlation") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "heatmap") {
  ggplot(data = featureResult_melted, aes(x = Var1, y = Var2, fill = value)) +
    geom_tile() +
    scale_fill_gradient2(low = "red", mid = "yellow", high = "green", midpoint = 0) +
    labs(title = title, x = "Features", y = "Features", fill = "Correlation") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
}
`
    }
    if(tech === 2){
    let tech = "Regression1: Pearson’s Correlation Coefficient"
    return `
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("reshape2", quietly = TRUE)) {
  install.packages("reshape2")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(reshape2))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
K = ${k}
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))

# Feature Selection Using Linear Model (Similar to f_regression)
X_data <- df[, X, drop = FALSE]
Y_data <- df[, Y, drop = FALSE]

# Fit a linear model for each feature (X) and compute the p-value
scores <- sapply(X, function(feature) {
  model <- lm(as.formula(paste("\`", Y, "\` ~ \`", feature, "\`", sep = "")), data = df)
  summary(model)$coefficients[2, 4]  # Extract the p-value for the feature
})

# Compute the "Score" for each feature (negative log of p-value as an example of feature importance)
feature_result <- data.frame(
  Features = names(scores),
  Score = -log10(scores)  # Use negative log of p-value as score (higher score = more significant feature)
)

# Get Top K Features Based on Score
feature_result <- feature_result[order(-feature_result$Score), ]
top_features <- feature_result[1:K, ]

# Plotting
if (plotType == "bar") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_bar(stat = "identity", fill = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "scatter") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_point(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "line") {
  ggplot(top_features, aes(x = Features, y = Score, group = 1)) +
    geom_line(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
}
`
    }
    if(tech === 3){
    let tech = "Classification1: ANOVA"
    return`
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("reshape2", quietly = TRUE)) {
  install.packages("reshape2")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(reshape2))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
K = ${k}
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))
# Calculate ANOVA F-statistics and p-values
anova_results <- sapply(X, function(feature) {
  formula <- as.formula(paste("\`", Y, "\` ~ \`", feature, "\`", sep = ""))
  
  model <- aov(formula, data = df)
  
  # Extract F-statistic from the ANOVA summary
  f_value <- summary(model)[[1]][1, "F value"]
  return(f_value)
})

# Create DataFrame of Features and their F-statistics
feature_result <- data.frame(
  Features = names(anova_results),
  Score = anova_results
)

# Get Top K Features Based on F-statistic
feature_result <- feature_result[order(-feature_result$Score), ]
top_features <- feature_result[1:K, ]

# Plotting
if (plotType == "bar") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_bar(stat = "identity", fill = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "F-statistic Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "scatter") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_point(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "F-statistic Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "line") {
  ggplot(top_features, aes(x = Features, y = Score, group = 1)) +
    geom_line(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "F-statistic Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
}
`
    }
    if(tech === 4){
    let tech = "Classification2: Chi-Squared"
    return`
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("reshape2", quietly = TRUE)) {
  install.packages("reshape2")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(reshape2))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
K = ${k}
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))

# Perform Chi-Squared Test for Feature Selection
chi2_scores <- sapply(X, function(feature) {
  # Create contingency table between feature and target variable
  contingency_table <- table(df[[feature]], df[[Y]])
  
  # Perform chi-squared test
  chi2_result <- chisq.test(contingency_table, simulate.p.value = TRUE)
  
  # Return the chi-squared statistic
  return(chi2_result$statistic)
})

# Create DataFrame of Features and their Chi-Squared Scores
feature_result <- data.frame(
  Features = names(chi2_scores),
  Score = chi2_scores
)

# Get Top K Features Based on Chi-Squared Score
feature_result <- feature_result[order(-feature_result$Score), ]
top_features <- feature_result[1:K, ]

# Plotting
if (plotType == "bar") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_bar(stat = "identity", fill = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Chi-Squared Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "scatter") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_point(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Chi-Squared Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "line") {
  ggplot(top_features, aes(x = Features, y = Score, group = 1)) +
    geom_line(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Chi-Squared Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
}
`
    }
    if(tech === 5){
    let tech = "Classification3: Mutual Information"
    return`
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("infotheo", quietly = TRUE)) {
  install.packages("infotheo")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(infotheo))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
K = ${k}
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))
    

# Feature Selection Using Mutual Information
# Calculate mutual information between each feature and the target variable
mutual_info_scores <- sapply(X, function(feature) {
  # Compute mutual information between the feature and the target
  mutual_info <- mutinformation(discretize(df[[feature]]), discretize(df[[Y]]))
  return(mutual_info)
})

# Create DataFrame of Features and their Mutual Information Scores
feature_result <- data.frame(
  Features = names(mutual_info_scores),
  Score = mutual_info_scores
)

# Get Top K Features Based on Mutual Information Score
feature_result <- feature_result[order(-feature_result$Score), ]
top_features <- feature_result[1:K, ]

# Plotting
if (plotType == "bar") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_bar(stat = "identity", fill = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Mutual Information Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "scatter") {
  ggplot(top_features, aes(x = Features, y = Score)) +
    geom_point(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Mutual Information Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "line") {
  ggplot(top_features, aes(x = Features, y = Score, group = 1)) +
    geom_line(color = rgb(runif(1), runif(1), runif(1))) +
    labs(title = title, x = "Features", y = "Mutual Information Score") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
}
`
    }
    if(tech === 6){
        let tech = "Principal Component Analysis"
        return`
if (!requireNamespace("ggplot2", quietly = TRUE)) {
  install.packages("ggplot2")
}
if (!requireNamespace("reshape2", quietly = TRUE)) {
  install.packages("reshape2")
}
suppressWarnings(library(ggplot2))
suppressWarnings(library(reshape2))


X <- c(${variable_X.map(e => `'${e}'`).join(',')})
Y <- "${target_Y}"
K = ${k}
num_comp <- as.integer(${specific_inputVal_pca}) 
plotSize <- c(${plot_size})
plotType <- "${plot_type}"
thresh <- as.numeric(${specific_inputVal_lowVar})
title <- "${tech}"

# Data Preparation
if (Y != "") {
  df <- df[, c(X, Y), drop = FALSE]
} else {
  df <- df[, X, drop = FALSE]
}
# Convert columns to numeric, ignoring errors
df[] <- lapply(df, function(col) suppressWarnings(as.numeric(col)))

# Standardization (Scaling the data)
scaled_data <- scale(df)  # This scales and centers the data

# PCA Analysis
pca_res <- prcomp(scaled_data, center = TRUE, scale. = TRUE)  # Perform PCA
pca_df <- as.data.frame(pca_res$x[, 1:num_comp])  # Take only the first 'num_comp' principal components
colnames(pca_df) <- paste("PC", 1:num_comp, sep = "")  # Naming columns PC1, PC2, ..., PCn

# Combine with target variable (if necessary)
if (exists("Y") && !is.null(Y)) {
  pca_df$Target <- df[[Y]]  # Add target variable to the PCA result
}

if (plotType == "bar") {
  # Create bar plot of PCA components using the correct variable names from melt()
  pca_plot <- ggplot(melt(pca_df), aes(x = variable, y = value, fill = variable)) +
    geom_bar(stat = "identity") +
    labs(title = title, x = "Principal Components", y = "Value") +
    theme_minimal() +
    theme(axis.text.x = element_text(angle = 45, hjust = 1))
} else if (plotType == "scatter") {
  # Scatter plot of the first two principal components
  pca_plot <- ggplot(pca_df, aes(x = PC1, y = PC2, color = Target)) +
    geom_point() +
    labs(title = title, x = "PC1", y = "PC2") +
    theme_minimal()
} else if (plotType == "line") {
  # Line plot of PCA components (if applicable)
  pca_plot <- ggplot(melt(pca_df), aes(x = Var1, y = value, group = Var1, color = Var1)) +
    geom_line() +
    labs(title = title, x = "Principal Components", y = "Value") +
    theme_minimal()
} else if (plotType == "heatmap") {
  # Heatmap of the PCA results (correlation matrix or values)
  pca_corr <- cor(pca_df)  # Calculate correlation matrix for the PCA results
  pca_plot <- ggplot(melt(pca_corr), aes(Var1, Var2, fill = value)) +
    geom_tile() +
    scale_fill_gradient2(midpoint = 0, low = "blue", high = "red", mid = "white") +
    labs(title = title, x = "Principal Components", y = "Principal Components") +
    theme_minimal()
}

# Display the plot
print(pca_plot)
`
    }
}
return `
# Choose operation to see demo code
# Otherwise, fell free to play with Sandbox.
# Have a nice day!
`
}

const FeatureSelectionR = () => {
  useCachedData()

  let dataset = useSelector(state => state.dataset)
  let dispatch = useDispatch()
  let [showModal, setShowModal] = useState(true)
  let [showOptions_Input_lowVar, setShowOptions_Input_lowVar] = useState(false)
  let [showOptions_Input_pca, setShowOptions_Input_pca] = useState(false)
  let result = useRef({})
  let sandboxRef = useRef(null)

  return (<div className="flex flex-col min-h-screen bg-gray-100">
    <Modal setIsOpen={setShowModal} isOpen={showModal}>
      <div className="flex flex-col p-4 gap-4">
        <div className="grid grid-cols-2 gap-4 grid-num-cat">
          <div className='flex items-center'>Variables X = <InlineTip info="Variables X can only be numerical" /></div>
          <MultiSelect zIndex={110} height="h-10" width="w-96" defaultText='Select Variable Columns' selections={dataset.num_cols} onSelect={e => result.current.variablesx = e} />
          <div className='flex items-center'>Target Y = <InlineTip info="Target Y can only be numerical" /></div>
          <DropDown zIndex={109} height="h-10" width="w-96" defaultText={'Select Target Column'} items={dataset.num_cols} onSelect={e => result.current.targety = e}></DropDown>
          <div className='flex items-center'>Select K=? Best Features <InlineTip info="Integer, must be smaller than the number of Variables X. Default: the number of Variables X" /> </div>
          <Input attrs={{ list: 'select_k_best', placeholder: 'K' }} onInput={(e, v) => result.current.k = v} />
          <datalist id="select_k_best_list"><option value="5"></option><option value="10"></option><option value="15"></option></datalist>
          <div className='flex items-center'>Feature selection technique</div>
          <DropDown zIndex={107} defaultText={'Select Technique'} height="h-10" width="w-96" items={
            // 0                                           1                               2                                           3                      4                                        5                                         6
            ['Removing Features with Low Variance', 'Correlation Matrix', 'Regression1: Pearson’s Correlation Coefficient', 'Classification1: ANOVA', 'Classification2: Chi-Squared', 'Classification3: Mutual Information', 'Principal Component Analysis']
              .map((name, i) => ({
                name,
                onClick(e) {
                  result.current.technique = i
                  if (i === 0 || i === 6) {
                    if (i === 0) {
                      setShowOptions_Input_pca(0)
                      setShowOptions_Input_lowVar(1)
                    }
                    if (i === 6) {
                      setShowOptions_Input_lowVar(0)
                      setShowOptions_Input_pca(1)
                    }
                  }
                  else {
                    setShowOptions_Input_lowVar(0)
                    setShowOptions_Input_pca(0)
                  }
                  return false
                }
              }))
          } />
          <Label customStyleText={`${showOptions_Input_lowVar ? '' : 'hidden'}`} text='Input Variance Threshold'><InlineTip info="Float. Default: 0.3" /></Label>
          <Input className={`${showOptions_Input_lowVar ? '' : 'hidden'}`}
            onInput={e => {
              result.current.specific_inputVal_lowVar = e.target.value
            }} />
          <Label customStyleText={`${showOptions_Input_pca ? '' : 'hidden'}`} text='Input Number of Components'><InlineTip info="Integer. Default: 2" /></Label>
          <Input className={`${showOptions_Input_pca ? '' : 'hidden'}`}
            onInput={e => {
              result.current.specific_inputVal_pca = e.target.value
            }} />
          <div className='flex items-center'>Plot size<InlineTip info="Adjust plot size (width, height). Default: 5,5" /></div>
          <Input attrs={{ list: 'plot_size', placeholder: 'Plot size' }} onInput={(e, v) => result.current.plotsize = v} />
          <div className='flex items-center'>Plot type<InlineTip info="Adjust plot type. Default: bar" /></div>
          <DropDown zIndex={105} defaultText={'Select plot type'} height="h-10" width="w-96" items={[
            'Bar', 'Scatter Plot', 'Line Graph', 'Heatmap'
          ]} onSelect={(e, i) => result.current.plottype = i} />
        </div>
        <div className="flex justify-end mt-10">
          <Button text='Confirm' width="w-64" onClick={async ()=>{
            setShowModal(false)

            console.log(result.current);
            let res = await fetchByJSON('feature_selection',{filename:dataset.filename,...result.current})
            let json = await res.json()
            let errorMsg = json['errorMsg']
            if(errorMsg && errorMsg != "''"){
                alert(errorMsg)
            }else{
              $('#display_results').html(json.para_result)
              document.getElementById("display_results_img").src = "data:image/png;charset=utf-8;base64,"+json.plot_url
            }
          }} />
        </div>
      </div>
    </Modal>
    <div className="button-style flex flex-row p-4 gap-4 items-center justify-start bg-gray-100 shadow-md">
      <Button text="Select operation" width="w-48" onClick={()=>{
        setShowModal(true)
      }}></Button>
      <Button disabled={true} text="Show code" width="w-48" onClick={()=>{
          sandboxRef.current.setCode(getCodeFromResult({ result: result.current }))
          sandboxRef.current.show()
      }}></Button>
    </div>

    <div className="flex flex-row mt-2 p-4 items-center justify-start bg-gray-100">
      <Sandbox ref={sandboxRef} dataset={dataset} additional={` `} />
    </div>

    <div className="flex flex-row p-4 items-center justify-start bg-gray-100">
      <div className="p-2">
        <img id="display_results_img" src="" />
      </div>
      <div className="p-2">
        <div id ="display_results" style={{ whiteSpace: 'pre-wrap' }} ></div>
      </div>
    </div>
  </div>)
}

export default FeatureSelectionR